export default __webpack_public_path__ + "static/media/iread3.ae5431a2.jpeg";